import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-shield-2",
  "use": "icon-si-glyph-shield-2-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol viewBox=\"0 0 17 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-shield-2\" id=\"icon-si-glyph-shield-2\">\n    <!-- Generator: Sketch 3.0.3 (7891) - http://www.bohemiancoding.com/sketch -->\n    <title>1033</title>\n    \n    <defs></defs>\n    <g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <path d=\"M8.99,0.062 C5.683,0.062 3.002,2.006 3.002,2.006 L3.008,8.06 C3.008,13.059 8.99,15.948 8.99,15.948 C8.99,15.948 14.973,13.226 14.973,8.045 C14.973,2.865 14.975,2.007 14.975,2.007 C14.975,2.007 12.295,0.062 8.99,0.062 L8.99,0.062 Z M9.053,14.056 C9.053,14.056 3.953,11.796 3.953,7.886 L3.949,2.467 C3.949,2.467 6.234,0.946 9.053,0.946 L9.053,14.056 L9.053,14.056 Z\" fill=\"#434343\" class=\"si-glyph-fill\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-shield-2.svg
// module id = pf8E
// module chunks = 62